import * as Yup from 'yup'

const TrainerDetailFormValidations = () => {
    return Yup.object().shape({
    })
}

export { TrainerDetailFormValidations }